export class CheckForDongleUpdateAction {
    constructor() {
        this.name = 'CheckForDongleUpdate';
        this.isDeviceAction = false;
        this.data = {};
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tGb3JEb25nbGVVcGRhdGVBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL0NoZWNrRm9yRG9uZ2xlVXBkYXRlQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLE1BQU0sT0FBTywwQkFBMEI7SUFBdkM7UUFDa0IsU0FBSSxHQUFHLHNCQUFzQixDQUFDO1FBQzlCLG1CQUFjLEdBQUcsS0FBSyxDQUFDO1FBQ2hDLFNBQUksR0FBZ0MsRUFBRyxDQUFDO0lBQ2pELENBQUM7Q0FBQSJ9